import {Button, Card} from 'platform/components';
import {Heading, HStack} from 'platform/foundation';

import {BulkPrintDocumentKey} from '@dms/api/workshop';
import i18n from '@dms/i18n';

import {suffixTestId, type RequiredTestIdProps} from 'shared/web';

interface GenerationResultRowProps extends RequiredTestIdProps {
  documentKey: BulkPrintDocumentKey;
  titleKey: string;
  url: string;
}

export function GenerationResultRow(props: GenerationResultRowProps) {
  const handleOpen = () => {
    window.open(props.url, '_blank');
  };

  return (
    <Card variant="inlineGrey">
      <HStack align="center" justify="space-between">
        <Heading size={4}>{i18n.t(props.titleKey)}</Heading>
        <Button
          variant="link"
          title={i18n.t('general.actions.open')}
          onClick={handleOpen}
          data-testid={suffixTestId(`open-${props.documentKey}`, props)}
        />
      </HStack>
    </Card>
  );
}
